/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { NonceChallengeOptions } from './NonceChallengeOptions';
import {
    NonceChallengeOptionsFromJSON,
    NonceChallengeOptionsFromJSONTyped,
    NonceChallengeOptionsToJSON,
    NonceChallengeOptionsToJSONTyped,
} from './NonceChallengeOptions';

/**
 * 
 * @export
 * @interface NonceChallenge
 */
export interface NonceChallenge {
    /**
     * 
     * @type {string}
     * @memberof NonceChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof NonceChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof NonceChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {NonceChallengeOptions}
     * @memberof NonceChallenge
     */
    options?: NonceChallengeOptions;
}



/**
 * Check if a given object implements the NonceChallenge interface.
 */
export function instanceOfNonceChallenge(value: object): value is NonceChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function NonceChallengeFromJSON(json: any): NonceChallenge {
    return NonceChallengeFromJSONTyped(json, false);
}

export function NonceChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': json['options'] == null ? undefined : NonceChallengeOptionsFromJSON(json['options']),
    };
}

export function NonceChallengeToJSON(json: any): NonceChallenge {
    return NonceChallengeToJSONTyped(json, false);
}

export function NonceChallengeToJSONTyped(value?: NonceChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': NonceChallengeOptionsToJSON(value['options']),
    };
}

